const missing = value => value === undefined || value === null || (typeof value === 'string' && !value.trim())

// 页面参数尚未传入是正常的布局状态，不等同于请求失败。
// 编辑器仍遵循原来的示例设备规则，运行时绝不回退到示例设备。
export function pageDevicePending (parameter = {}, context = {}, editing = false) {
  return !!parameter && parameter.deviceSource === 'page' && missing(editing ? parameter.deviceId : context.deviceId)
}

export function pageDeviceSkeleton (parameter = {}, status) {
  return !!parameter && parameter.deviceSource === 'page' && ['pending', 'loading', 'waiting', 'empty'].includes(status)
}
